import React from 'react'
import TrackedLink from './TrackedLink'

const ContactButton = ({ contactByEmail, link, supplierId, trackingKey, className, text }) => {
  return (
    <TrackedLink
      url={contactByEmail ? `mailto:${link}` : link}
      supplierId={supplierId}
      eventType={trackingKey}
      linkClasses={`pro-small button contact-button ${className}`}
      target={contactByEmail ? '_self' : '_blank'}
    >
      {text || 'Contact Us'}
    </TrackedLink>
  )
}

export default ContactButton
